import React from 'react';

// THE segmented filter control — one component, every page, so filters look
// identical everywhere and clients never re-learn a control.
const SegmentControl = ({ label, options, value, onChange, size = 'md', trailing = null }) => {
  // Every filter control on a row must end on the SAME baseline (Apal
  // 2026-09-25: "filters gotta be aligned row etc."). Segment heights used
  // to come out of their button padding — 40px at sm, 46px at md — next to
  // 36px selects, so the row's bottom edge was ragged. The track is now a
  // fixed 36px (h-9, matching a select) and the buttons stretch to fill it,
  // so size only changes type and horizontal padding, never height.
  // md is the one bar size: 13px type, 9px sides — tight enough that a
  // page's filters and the global ones share ONE line (Apal 2026-10-15)
  const pad = size === 'sm' ? 'px-2 text-[11px]' : 'px-[9px] text-[13px]';
  return (
    <div>
      <label className="text-dark-400 text-[11px] uppercase tracking-widest font-semibold block mb-1.5">{label}</label>
      <div className="flex items-center gap-1.5">
        <div className="h-9 flex items-stretch gap-1 bg-dark-700 p-1 rounded-lg border border-dark-600/30">
          {options.map(o => (
            <button key={o.key} onClick={() => onChange(o.key)} title={o.title || ''}
              className={`${pad} flex items-center rounded-md font-semibold transition-all whitespace-nowrap ${value === o.key ? `${o.activeBg || 'bg-primary-600 text-white'} shadow-md` : 'text-dark-300 hover:text-white hover:bg-dark-600'}`}>
              {o.label}
            </button>
          ))}
        </div>
        {trailing}
      </div>
    </div>
  );
};

export default SegmentControl;
